import { Component, inject, input } from '@angular/core'
import { SharedConstantService } from '../../services'
import { Crop } from '@agroone/entities'
import { TranslateConstantPipe } from '../../pipes'

@Component({
  selector: 'app-croptype-variety',
  templateUrl: './croptype-variety.component.html',
  imports: [TranslateConstantPipe],
})
export class CroptypeVarietyComponent {
  readonly crop = input.required<Crop>()

  constantService: SharedConstantService = inject(SharedConstantService)

  get varietyName() {
    return this.crop().varietyName
  }

  get varietalType() {
    return this.crop().varietalType
  }

  get varietalTypes() {
    return this.constantService.getFilteredByRegionAndCroptype(
      this.constantService.varietalTypes,
      this.crop().region,
      this.crop().cropType,
    )
  }
}
